import React from "react";

import "./Placeholders.scss";

export default ({ height = 171 }) => (
  <div className="placeholders placeholder-paragraph" style={{ height }}></div>
);
